export default __webpack_public_path__ + "static/media/kubernetes_logo.ce1f338c.png";